import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/auth");
      return;
    }

    axios
      .post(`${API}/auth/google/callback`, { session_id }, { withCredentials: true })
      .then((r) => {
        setUser(r.data);
        navigate("/dashboard", { state: { user: r.data } });
      })
      .catch(() => navigate("/auth"));
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#0F172A" }}
    >
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white font-bold">Signing you in...</p>
      </div>
    </div>
  );
}
